import { render } from "./ChangePin.vue?vue&type=template&id=2cdd50c0"
import script from "./ChangePin.vue?vue&type=script&lang=js"
export * from "./ChangePin.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__